export default __webpack_public_path__ + "static/media/dripicons-v2.4cecedd1.svg";